import { FirebaseDocRefType, FirebaseTimestampType } from 'firebase/index'

export type MessageType = {
  bread_ref?: FirebaseDocRefType
  body: string
  channel: Channel
  created_at?: FirebaseTimestampType
  external_link: string
  has_sound: boolean
  html: string
  priority: Priority
  publish_status: PublishStatus
  notified_at?: FirebaseTimestampType
  send_time: FirebaseTimestampType
  store_ref?: FirebaseDocRefType
  store_timesale_ref?: FirebaseDocRefType
  title: string
  user_ids: string[] | null
  updated_at?: FirebaseTimestampType
}

export const CHANNEL = {
  sacri: '運営からのお知らせ',
  'bread/store': '店舗からのお知らせ',
  'bread/bread': '店舗からの商品のお知らせ',
  'bread/stock': '店舗からの在庫のお知らせ',
} as const
export type Channel = keyof typeof CHANNEL

export const PRIORITY = {
  high: '通知パーミッションがなくても通知',
  medium: '通知パーミッションがあれば通知',
  low: '通知を行わない(お知らせ登録のみ)',
} as const

export type Priority = keyof typeof PRIORITY

export const PUBLISH_STATUS = {
  '0': '下書き',
  '1': '送信予約',
  '2': '送信済み',
} as const

export type PublishStatus = keyof typeof PUBLISH_STATUS
